<template>
    <div class="about-ep">
        <h3 class="indent">Billet Casting</h3>
        <p class="indent">Alcomet produces the billets for its extrusion operations in-house, using
          the advanced Wagstaff Hot Top Billet Casting System, one of the leading
          technologies for high-quality aluminium billet production.</p>
      <p class="indent">The casting line is dedicated to “soft alloy” production, covering 1xxx
        and 6xxx series alloys. Chemical composition is precisely controlled and
        guaranteed in accordance with international standards or customerspecific
        specifications, ensuring consistent material quality and reliable
        performance throughout the extrusion process.</p>
        <div class="about-ep-table">
          <div class="about-ep-table-row">
            <span>Billet diameters:</span>
            <span>4", 6", 7", 8", 10"</span>
          </div>
          <div class="about-ep-table-row">
            <span>Annual capacity:</span>
            <span>50 000 tons</span>
          </div>
          <div class="about-ep-table-row">
            <span>Max length</span>
            <span>6 300 mm</span>
          </div>
        </div>
        <img class="about-ep-img" src="/static/img/about/ep/1.jpg" alt="Rolling">
        <h3 class="indent">Extrusion</h3>
        <p class="indent">Alcomet operates an advanced extrusion plant with six presses ranging
          from 600 to 4,000 tonnes and an annual production capacity of approximately
          45,000 tonnes. The plant specialises in soft alloys for architecture, building
          & construction, transportation, and machine-building, offering profiles
          tailored to demanding customer requirements.</p>
      <p class="indent">The latest addition is the 40 MN Presezzi extrusion line with energy-saving
        system, designed for the production of larger, more complex, and highvalue
        aluminium profiles. The new line expands Alcomet’s capabilities in
        demanding applications including automotive, solar energy, defence, and
        construction.</p>
      <p class="indent">With advanced extrusion technology and in-house billet production,
        Alcomet combines precision, flexibility, and efficiency to deliver highquality
        profiles for increasingly complex applications.</p>

      <div class="about-ep-table">
        <div class="about-ep-table-row">
          <span>Annual capacity</span>
          <span>45 000 tonnes</span>
        </div>
        <div class="about-ep-table-row">
          <span>6 extrusion presses</span>
          <span>6MN, 13MN, 18MN,
20MN, 25MN, 40 MN</span>
        </div>
        <div class="about-ep-table-row">
          <span>Billet size</span>
          <span>4" , 6" , 7" , 8" , 10"</span>
        </div>
        <div class="about-ep-table-row">
          <span>Profile weight</span>
          <span>0.05 to 20 kg/m</span>
        </div>
        <div class="about-ep-table-row">
          <span>Alloys</span>
          <span>6060, 6061, 6063, 6005, 6082, 1100/1200</span>
        </div>
        <div class="about-ep-table-row">
          <span>Tempers</span>
          <span>T4, T5, T6, T66</span>
        </div>
        <div class="about-ep-table-row">
          <span>Circumference</span>
          <span>max. 380 mm</span>
        </div>
        <div class="about-ep-table-row">
          <span>Max length</span>
          <span>14 000 mm</span>
        </div>
      </div>

        <div class="about-ep-table">
          <div class="about-ep-table-row about-ep-table-row-fifth">
            <span class="about-ep-table-fifth">Press size</span>
            <span class="about-ep-table-fifth">600</span>
            <span class="about-ep-table-fifth">1300</span>
            <span class="about-ep-table-fifth">1800</span>
            <span class="about-ep-table-fifth">2000</span>
            <span class="about-ep-table-fifth">2500</span>
            <span class="about-ep-table-fifth">4000</span>
          </div>
          <div class="about-ep-table-row about-ep-table-row-fifth">
            <span class="about-ep-table-fifth"></span>
            <span class="about-ep-table-fifth">4"</span>
            <span class="about-ep-table-fifth">6"</span>
            <span class="about-ep-table-fifth">7"</span>
            <span class="about-ep-table-fifth">8"</span>
            <span class="about-ep-table-fifth">8"</span>
            <span class="about-ep-table-fifth">10"</span>
          </div>
          <div class="about-ep-table-row about-ep-table-row-fifth">
            <span class="about-ep-table-fifth">Alloys</span>
            <span class="about-ep-table-fifth">6060,<br>6063</span>
            <span class="about-ep-table-fifth">1200,<br>6060,<br>6063,<br>6005</span>
            <span class="about-ep-table-fifth">6060,<br>6063,<br>6005</span>
            <span class="about-ep-table-fifth">6060,<br>6063,<br>6005,<br>6082</span>
            <span class="about-ep-table-fifth">6060,<br>6063,<br>6005,<br>6082</span>
            <span class="about-ep-table-fifth">6060,<br>6063,<br>6005,<br>6061,<br>6082</span>
          </div>
          <div class="about-ep-table-row about-ep-table-row-fifth">
            <span class="about-ep-table-fifth">CCD (mm)<br>- solid<br>profiles</span>
            <span class="about-ep-table-fifth">MAX.<br> 90</span>
            <span class="about-ep-table-fifth">MAX.<br> 150</span>
            <span class="about-ep-table-fifth">MAX.<br> 170</span>
            <span class="about-ep-table-fifth">MAX.<br> 200</span>
            <span class="about-ep-table-fifth">MAX.<br> 300</span>
            <span class="about-ep-table-fifth">MAX.<br> 380</span>
          </div>
          <div class="about-ep-table-row about-ep-table-row-fifth">
            <span class="about-ep-table-fifth">CCD (mm)<br>- hollow<br>profiles</span>
            <span class="about-ep-table-fifth">MAX.<br> 70</span>
            <span class="about-ep-table-fifth">MAX.<br> 130</span>
            <span class="about-ep-table-fifth">MAX.<br> 150</span>
            <span class="about-ep-table-fifth">MAX.<br> 180</span>
            <span class="about-ep-table-fifth">MAX.<br> 280</span>
            <span class="about-ep-table-fifth">MAX.<br> 360</span>
          </div>
          <div class="about-ep-table-row about-ep-table-row-fifth">
            <span class="about-ep-table-fifth">Weight<br>(kg/m)</span>
            <span class="about-ep-table-fifth">0.05-0.7</span>
            <span class="about-ep-table-fifth">0.1-1.8</span>
            <span class="about-ep-table-fifth">0.2-2.3</span>
            <span class="about-ep-table-fifth">0.35-9</span>
            <span class="about-ep-table-fifth">0.5-10</span>
            <span class="about-ep-table-fifth">0.7-20</span>
          </div>
          <div class="about-ep-table-row about-ep-table-row-fifth">
            <span class="about-ep-table-fifth">Length at<br>the press<br>(mm)</span>
            <span class="about-ep-table-fifth">1000-<br>7000</span>
            <span class="about-ep-table-fifth">1000-<br>8000</span>
            <span class="about-ep-table-fifth">1000-<br>8000</span>
            <span class="about-ep-table-fifth">1000-<br>11500</span>
            <span class="about-ep-table-fifth">1500-<br>8000</span>
            <span class="about-ep-table-fifth">2000-<br>14000</span>
          </div>
          <div class="about-ep-table-row about-ep-table-row-fifth">
            <span class="about-ep-table-fifth">Wall<br>thickness<br>(mm)</span>
            <span class="about-ep-table-fifth">MIN.<br>0.8</span>
            <span class="about-ep-table-fifth">MIN.<br>1.0</span>
            <span class="about-ep-table-fifth">MIN.<br>1.0</span>
            <span class="about-ep-table-fifth">MIN.<br>1.2</span>
            <span class="about-ep-table-fifth">MIN.<br>1.2</span>
            <span class="about-ep-table-fifth">MIN.<br>1.7</span>
          </div>
        </div>
        <img class="about-ep-img" src="/static/img/about/ep/2.jpg" alt="Rolling">
        <h3 class="indent">Surface Treatment</h3>
        <p class="indent">Alcomet offers in-house anodizing and powder coating to enhance the
          appearance, durability, and corrosion resistance of aluminium profiles.
          These finishing capabilities allow customers to achieve both highperformance
          surfaces and distinctive architectural finishes.</p>
        <p class="indent">Anodizing is available in silver, gold, bronze and black, with standard
          matte, brushed or sandblasted finishes. Powder coating provides a
          virtually unlimited choice of colours based on RAL standards or customer
          specifications.</p>
        <p class="indent">Both finishing lines operate in accordance with ISO 14001, supporting
          Alcomet’s commitment to quality, environmental responsibility, and
          sustainable production.</p>

        <p><span class="strong">Powder coating</span> - Powder coating provides aluminium profiles with a durable, high-quality decorative finish while enhancing their resistance to abrasion, impact,
          UV exposure, and corrosion. With a wide range of colours and finishes
          available, it combines long-lasting protection with design flexibility for
          demanding architectural and industrial applications.</p>
        <div class="about-ep-table">
          <div class="about-ep-table-row">
            <span>Maximum length:</span>
            <span>7200 mm</span>
          </div>
          <div class="about-ep-table-row">
            <span>Coating thickness</span>
            <span>60-200 microns</span>
          </div>
          <div class="about-ep-table-row">
            <span>Powder coating capacity</span>
            <span>6000 tons per year</span>
          </div>
          <div class="about-ep-table-row">
            <span>Colours</span>
            <span>According to RAL catalogue or customer specification</span>
          </div>
        </div>
        <img class="about-ep-img" src="/static/img/about/ep/3.jpg" alt="Rolling">
        <p class="indent"><span class="strong">Anodizing</span> - Anodizing is an electrochemical surface treatment that forms a durable
          protective oxide layer on aluminium, enhancing its hardness, corrosion
          resistance, and appearance. Alcomet’s new computer-controlled automatic
          line performs the process through pre-treatment, anodizing, colouring, and
          hot sealing, ensuring consistent and high-quality surface finishes.</p>
        <img class="about-ep-img" src="/static/img/about/ep/31.jpg" alt="Rolling">
        <div class="about-ep-table">
          <div class="about-ep-table-row">
            <span>Pre-treatment:</span>
            <span>E6 (matt finish)</span>
          </div>
          <div class="about-ep-table-row">
            <span>Max. length</span>
            <span>6500 mm</span>
          </div>
          <div class="about-ep-table-row">
            <span>Coating thickness</span>
            <span>10-25 microns</span>
          </div>
          <div class="about-ep-table-row">
            <span>Surface fifinish</span>
            <span>standard, brushed, shot blasted</span>
          </div>
          <div class="about-ep-table-row">
            <span>Anodizing capacity</span>
            <span>6000 tons per year</span>
          </div>
        </div>
        <div class="colors">
            <div class="color">
                <div class="color-square" :style="{ backgroundColor: 'rgba(174,175,176,1)'}"></div>
                <span>Natural</span>
                <span>(C0)</span>
            </div>
            <div class="color">
                <div class="color-square" :style="{ backgroundColor: 'rgba(184,159,94,1)'}"></div>
                <span>Champagne</span>
                <span>(C2)</span>
            </div>
            <div class="color">
                <div class="color-square" :style="{ backgroundColor: 'rgba(192,135,56,1)'}"></div>
                <span>Gold</span>
                <span>(C3)</span>
            </div>
            <div class="color">
                <div class="color-square" :style="{ backgroundColor: 'rgba(151,143,118,1)'}"></div>
                <span>Light bronze</span>
                <span>(C32)</span>
            </div>
            <div class="color">
                <div class="color-square" :style="{ backgroundColor: 'rgba(117,102,74,1)'}"></div>
                <span>Dark bronze</span>
                <span>(C33)</span>
            </div>
            <div class="color">
                <div class="color-square" :style="{ backgroundColor: 'rgba(0,0,0,1)'}"></div>
                <span>Black</span>
                <span>(C35)</span>
            </div>
            <div class="color">
                <div class="color-square" :style="{ backgroundColor: 'rgba(150,150,150,1)'}"></div>
                <span>Sandblasting</span>
                <span>(E6/C0 SB)</span>
            </div>
        </div>
        <h3 class="indent">Fabrication</h3>
        <p class="indent">Alcomet provides in-house profile fabrication to deliver ready-to-use
          components and streamline customers’ production processes. Our
          capabilities include CNC machining, drilling, milling, punching and
          precision cutting, supported by a state-of-the-art 5-axis CNC line for highprecision
          processing of profiles up to 7,200 mm in length.</p>
      <p class="indent">By combining extrusion, surface treatment, and fabrication under one roof,
        Alcomet offers greater process control, consistent quality, and optimised
        logistics, helping customers simplify their supply chain and accelerate
        production.</p>
        <div class="about-ep-table">

          <div class="about-ep-table-row about-ep-table-row-title">
            <span>CNC-machining:</span>
          </div>
          <div class="about-ep-table-row">
            <span>3 precision cutting lines</span>
          </div>
          <div class="about-ep-table-row">
            <span>1 angular cutting line</span>
          </div>
          <div class="about-ep-table-row">
            <span>2 CNC centres, 7200 mm length</span>
          </div>
          <div class="about-ep-table-row">
            <span>2 punching lines</span>
          </div>




        </div>
        <img class="about-ep-img" src="/static/img/about/ep/4.jpg" alt="Rolling">
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.about-ep {
  align-items: center;
  display: flex;
  flex-direction: column;
}
.about-ep > p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.about-ep > h3 {
  font-size: 22px;
  font-weight: 500;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.about-ep-table {
  margin: 15px 0;
  width: 60%;
}
.about-ep-table-row {
  align-items: center;
  background-color: #eef2f8;
  border-radius: 6px;
  display: flex;
  height: 50px;
  justify-content: space-between;
  margin-bottom: 8px;
  padding: 0 20px;
  width: 100%;
}
.about-ep-table-row-title {
  background-color: transparent;
}
.about-ep-table-row-fifth {
  height: initial;
  min-height: 50px;
  padding: 15px 20px;
}
.about-ep-table-row > span,
.about-ep-table-fifth {
  font-weight: 700;
  font-size: 16px;
  color: #1a437c;
}
.about-ep-table-row-title > span {
  font-weight: 400;
}
.about-ep-table-fifth {
  display: inline-flex;
  justify-content: center;
  text-align: center;
  width: 20%;
}
.about-ep-img {
  border-radius: 5px;
  height: auto;
  margin: 20px auto;
  min-height: 1px;
  width: 80%;
}
.colors {
  display: flex;
  margin: 15px 0;
}
.color {
  align-items: center;
  display: flex;
  flex-direction: column;
}
.color-square {
  border-radius: 6px;
  height: 8vw;
  margin: 10px;
  width: 8vw;
}
@media screen and (max-width: 1000px) {
  .about-ep p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .about-ep-table,
  .about-ep > h3 {
    width: 100%;
    padding: 0 30px;
  }
  .about-ep-img {
    width: calc(100% - 60px);
  }
  .color > span {
    font-size: 12px;
  }
}
@media screen and (max-width: 600px) {
  .about-ep-table-row > span,
  .about-ep-table-fifth {
    font-size: 12px;
  }
  .about-ep-table-row-fifth {
    padding: 15px;
  }
  .colors {
    flex-direction: column;
    padding: 0 30px;
    width: 100%;
  }
  .color {
    flex-direction: row;
  }
  .color-square {
    height: 10vw;
    width: 10vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about/ExtrusionPlant.vue